import { makeStyles } from '@material-ui/core';


export const useReleaseTagPageStyles = makeStyles(() => ({
  layoutWrapper: {
    display: 'flex',
    justifyContent: 'center',
    padding: 32,
  },
  contentWrapper: {
    width: 620,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
}));

export const useReleaseTagFormStyles = makeStyles(theme => ({
  tagFormCard: {
    padding: 16,
  },
  inputLabel: {
    marginTop: 4,
    marginBottom: 4,
  },
  filledInput: {
    marginBottom: 24,
  },
  numberInput: {
    '& input': {
      textAlign: 'center',
      '-moz-appearance': 'textfield',
    },
    width: 60,
    height: 40,
    textAlign: 'center',
  },
  versionInputWrapper: {
    display: 'flex',
  },
  serviceVersionsCard: {
    marginTop: 12,
  },
  clearTagButton: {
    color: theme.palette.error.main,
  },
  helperText: {
    height: 20,
    color: theme.palette.error.main,
  },
  notification: { width: '420px', backgroundColor: 'white' },
}));
